import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  ExcelModule, ExcelService,
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../../../../shared/common';
import {
  LoadingIndicatorModule
} from '../../../../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../../../../shared/layout/components/breadcrumb/breadcrumb.module';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';
import {AgmCoreModule} from '@agm/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {EditorModule} from '@progress/kendo-angular-editor';
import {MatExpansionModule} from '@angular/material/expansion';
import {ExcelExportModule} from '@progress/kendo-angular-excel-export';
import {ImportClientsService} from './import-clients.service';
import {ImportComponent} from './import.component';
import {ImportDialogComponent} from './import-dialog.component';
import {FileSelectModule} from '@progress/kendo-angular-upload';

@NgModule({
  declarations: [
    ImportComponent,
    ImportDialogComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    EditorModule,
    ExcelExportModule,
    ExcelModule,
    FileSelectModule,
    MatExpansionModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    FlexLayoutModule
  ],
  providers: [
    ImportClientsService
  ],
  entryComponents: [
    ConfirmDialogComponent,
    ImportDialogComponent
  ],
})
export class ImportModule {
}
